import { ApolloQueryResult } from "@apollo/client";
import { Layout } from "components/layout";
import { ProductCard } from "components/product-card";
import { PifAndVoucherCards } from "components/shop/pif-voucher-cards";
import { SubCard } from "components/sub-card";
import {
  GetAllProductsForShopDocument,
  GetAllProductsForShopQueryResult,
  GetAllSubsForShopDocument,
  GetAllSubsForShopQuery,
  GetAllSubsForShopQueryResult,
  ProductCardDataFragment,
} from "lib/graphql-generated";
import { addApolloState, initializeApollo } from "lib/hooks/apollo-client";
import { GetServerSideProps } from "next";

interface Props {
  products: ProductCardDataFragment[];
  subs: GetAllSubsForShopQuery["subscriptions"];
}

export const getServerSideProps: GetServerSideProps = async () => {
  const client = initializeApollo();

  const { data }: ApolloQueryResult<GetAllProductsForShopQueryResult["data"]> =
    await client.query({
      query: GetAllProductsForShopDocument,
    });

  const {
    data: subsData,
  }: ApolloQueryResult<GetAllSubsForShopQueryResult["data"]> =
    await client.query({
      query: GetAllSubsForShopDocument,
    });

  return addApolloState(client, {
    props: {
      products: data.products,
      subs: subsData.subscriptions,
    } as Props,
  });
};

export const Shop = ({ products, subs }: Props) => {
  return (
    <>
      <Layout pageName='Shop' className='max-w-screen-2xl m-auto'>
        <article className='flex flex-row flex-wrap px-4 md:px-8 lg:px-4 2xl:px-0'>
          <h1 className='header text-4xl text-center md:text-left py-4 w-full'>
            Subscriptions
          </h1>
          <section className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 w-full gap-4 md:gap-8 lg:gap-16 pb-16 justify-items-center md:justify-items-start'>
            {subs.map((p) => (
              <SubCard sub={p} key={p.id} />
            ))}
          </section>
        </article>
        <article className='flex flex-row flex-wrap px-4 md:px-8 lg:px-4 2xl:px-0'>
          <h1 className='header text-4xl text-center md:text-left py-4 w-full'>
            Vouchers
          </h1>
          <section className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 w-full gap-4 md:gap-8 lg:gap-16 pb-16 justify-items-center md:justify-items-start'>
            <PifAndVoucherCards />
          </section>
        </article>
        <article className='flex flex-row flex-wrap px-4 md:px-8 lg:px-4 2xl:px-0'>
          <h1 className='header text-4xl text-center md:text-left py-4 w-full'>
            Merchandise
          </h1>
          <section className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 w-full gap-4 md:gap-8 lg:gap-16 pb-16 justify-items-center md:justify-items-start'>
            {products.map((p) => (
              <ProductCard product={p} key={p.id} />
            ))}
          </section>
        </article>
      </Layout>
    </>
  );
};

export default Shop;
